import styled from "@emotion/styled";
import { Box, Button, Typography } from "@mui/material";
import theme from "../../theme";

export const RemindAndRevokeBtn = styled(Button)`
  height: 25px;
  border-color: grey;
  text-transform: capitalize;
  font-weight: normal;
`;

export const ReminderSuggestion = styled(Typography)`
  font-size: 14px;
  font-style: italic;
  margin-top: 2px;
  color: ${theme.palette.grey[600]};
`;

export const ReminderHeading = styled(Typography)`
  font-size: 16px;
  margin-bottom: 10px;
`;

export const ReferralInviteActionsWrapper = styled(Box)`
  margin-left: 3px;
  padding: 10px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  border-left: 4px solid ${theme.palette.primary.main};
`;

export const ReferralInviteActionsStyle = styled(Box)`
  display: flex;
  align-items: center;
  padding-top: 10px;
`;
